import request from './fetch';

export function getProjectList (data) {
  return request({
    url: '/v1/consumer-processing/project',
    method: 'get',
    params: data
  });
}

export function getProjectDetail (projectId) {
  return request({
    url: '/v1/consumer-processing/project/' + projectId,
    method: 'get',
  });
}

export function postProjectDetail (data) {
  return request({
    url: '/v1/consumer-processing/project',
    method: 'post',
    data
  });
}

export function putProject (id, data) {
  return request({
    url: '/v1/consumer-processing/project/' + id,
    method: 'put',
    data
  });
}

export function deleteProject(data) {
  return request({
    url: '/v1/consumer-processing/project',
    method: 'delete',
    data
  });
}

export function getProjectResponse (projectId, params, data = {}) {
  const newDataParams = {
    ...params,
    'advanced_condition': data
  };
  return request({
    url: `/v1/consumer-processing/project/${projectId}/response/search`,
    method: 'post',
    data: newDataParams
  });
}

export function getResponseTemplate (projectId) {
  return request({
    url: `/v1/consumer-processing/project/${projectId}/response/template`,
    method: 'get',
    headers: {
      responseType: 'blob',
    },
  });
}

export function putBatchResponse (projectId, data) {
  return request({
    url: `/v1/consumer-processing/project/${projectId}/response`,
    method: 'put',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
    data
  });
}

export function postProjectResponse (projectId, data) {
  return request({
    url: `/v1/consumer-processing/project/${projectId}/response`,
    method: 'post',
    data: data
  });
}

export function putResponse (responseId, data) {
  return request({
    url: `/v1/consumer-processing/response/${responseId}`,
    method: 'put',
    data: data
  });
}

export function deleteResponse (id) {
  return request({
    url: `/v1/consumer-processing/response/${id}`,
    method: 'delete'
  });
}

export function uploadVideo (data) {
  return request({
    url: '/v1/consumer-processing/file',
    // url: '/azure_file',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
    data
  });
}

export function getShowreelList (data) {
  return request({
    url: '/v1/consumer-processing/showreel',
    method: 'get',
    params: data
  });
}

export function postShowreel(data) {
  return request({
    url: '/v1/consumer-processing/showreel',
    method: 'post',
    data
  });
}

export function putShowreel(id, data) {
  return request({
    url: '/v1/consumer-processing/showreel/' + id,
    method: 'put',
    data
  });
}

export function getShowreelDetail(id) {
  return request({
    url: '/v1/consumer-processing/showreel/' + id,
    method: 'get'
  });
}

export function deleteShowreel(id) {
  return request({
    url: '/v1/consumer-processing/showreel/' + id,
    method: 'delete'
  });
}

export function createShowreelVideo(showreelId, params) {
  return request({
    url: `/v1/consumer-processing/showreel/${showreelId}`,
    method: 'post',
    data: params
  });
}

export function deleteShowreelItem(showreelId, itemId) {
  return request({
    url: `/v1/consumer-processing/showreel/${showreelId}/item/${itemId}`,
    method: 'delete'
  });
}

export function postProInsight(proId) {
  return request({
    url: `/v1/consumer-processing/project/${proId}/insight`,
    method: 'post'
  });
}

export function putShowreelSort(showreelId, itemId, sortId) {
  return request({
    url: `/v1/consumer-processing/showreel/${showreelId}/item/${itemId}`,
    method: 'put',
    data: {
      sort_order: sortId
    }
  });
}

export function postCeleryTask(proId, taskName) {
  return request({
    url: '/v1/celery_task',
    method: 'post',
    data: {
      task_name: taskName,
      parameters: [+proId]
    }
  });
}

export function postAIChat(params) {
  return request({
    url: '/v1/consumer-processing/ai-chat',
    method: 'post',
    data: params
  });
}

// filter
export function getCategory() {
  return request({
    url: '/v1/consumer_theater/category',
    method: 'get'
  });
}

export function getDictionary(type) {
  return request({
    url: '/v1/consumer_theater/dictionary',
    method: 'get',
    params: {
      type: type
    }
  });
}

export function getGeographicRegion() {
  return request({
    url: '/v1/consumer_theater/geographic_region',
    method: 'get'
  });
}

export function getByTopic(category) {
  return request({
    url: '/v1/consumer_theater/getByTopic',
    method: 'get',
    params: {
      category
    }
  });
}

// migrate to ct
export function migrateToCT(params) {
  return request({
    url: '/v1/consumer-processing/migrate',
    method: 'POST',
    data: params
  });
}